import script from "./Paginate.vue?vue&type=script&setup=true&lang=js"
export * from "./Paginate.vue?vue&type=script&setup=true&lang=js"

import "./Paginate.vue?vue&type=style&index=0&id=1242bc8b&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1242bc8b"]])

export default __exports__